export default __webpack_public_path__ + "static/media/Icon-Technology-Outline-Code.2a8b71d3.svg";